import { gql } from "@apollo/client"

// Separate from the application list queries. A Coach Tools without this field
// rejects the whole document, and a cached narrower selection must not replace
// the list those screens already loaded.
export const SECTION_EMPLOYMENT_VERIFICATION_QUERY = gql`
  query SectionEmploymentVerification {
    membershipApplications(applicationType: member) {
      id
      awaitingSectionEmploymentVerification
    }
  }
`
